import React from "react";

import Box from "../Box";

import styled from "styled-components";
import { CTag, CText } from "@carrefour/design-system-components-react";
import BaseDashboardCard from "../BaseDashboardCard";
import useBreakPoint from "../../utils/useBreakPoint";
import { DriveOrders } from "../../types/drive";
import { useTranslation } from "react-i18next";

const Text = styled(CText)<{ color?: string }>`
  color: ${(props) => props.color};
  font-family: system-ui;
`;
const CTagCustum = styled(CTag)<{ width?: string }>`
  font-family: system-ui;
  border-radius: 4px;
  width: ${(props) => props.width};
  font-size: large;
  font-weight: 700;
  size: 28px;
`;
type OrderStatusCardProps = {
  orderDriveData: DriveOrders;
  orderLadData: DriveOrders;
  isUnavailable: boolean;
  messageError?: string;
  isLoading: boolean;
  openInformationModal: (title?: string) => void;
};

const BoxCustom = styled(Box)<{ gap?: string; isBorded?: boolean }>`
  gap: ${(props) => props.gap};
  display: flex;
  border-bottom: ${(props) => (props?.isBorded ? " 1px solid #D9D9D9" : "")};
`;

const OrderStatusCard = ({
  orderDriveData,
  orderLadData,
  ...res
}: OrderStatusCardProps) => {
  const isBreak = useBreakPoint();

  const {t}=useTranslation();
  return (
    <BaseDashboardCard
      hasModal={true}
      title={t('ecommerce.commande_du_jour')}
      size={"big"}
      importedDateTime={orderDriveData?.importedDateTime || orderLadData?.importedDateTime}
      {...res}
    >
      <BoxCustom
        justifyContent={"flex-start"}
        alignItems={"flex-start"}
        flexDirection={"column"}
        gap="1rem"
      >
        {orderDriveData &&
          itemOrder(
            t('ecommerce.drive'),
            t('ecommerce.inProgress'),
            t('ecommerce.toPrepare'),
            t('ecommerce.preparees'),
            t('ecommerce.livrees'),
            orderDriveData?.inProgress,
            orderDriveData?.toPrepare,
            orderDriveData?.delivered,
            orderDriveData?.ready,
            isBreak
          )}
        {orderDriveData && orderLadData && (
          <BoxCustom isBorded={true} width={"100%"}></BoxCustom>
        )}
        {orderLadData &&
          itemOrder(
            t('ecommerce.lad'),
            t('ecommerce.inProgress'),
            t('ecommerce.toPrepare'),
            t('ecommerce.preparees'),
            t('ecommerce.livrees'),
            orderLadData?.inProgress,
            orderLadData?.toPrepare,
            orderLadData?.delivered,
            orderLadData?.ready,
            isBreak
          )}
      </BoxCustom>
    </BaseDashboardCard>
  );
};

const itemOrder = (
  name: string,
  inProgressLabel: string,
  toPrepareLabel: string,
  prepareesLabel: string,
  livreesLabel: string,
  inProgress: number,
  toPrepare: number,
  delivered: number,
  ready: number,
  isBreak: string
) => {

  return (
    <BoxCustom
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      gap="6px"
    >
      <Box textAlign={"left"}>
        <Text size={"l"} bold tagStyle="h3">
          {name}
        </Text>
      </Box>
      <BoxCustom
        display={"flex"}
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
        >
          <Text size={"s"}>{inProgressLabel}</Text>
          <CTagCustum
            status={"error"}
            hasBorder={false}
            size="l"
            width={isBreak === "phone" ? "100px" : "250px"}
          >
            {!isNaN(inProgress)
              ? `${new Intl.NumberFormat("fr-FR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }).format(inProgress)}`
              : "-"}
          </CTagCustum>
        </BoxCustom>
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
        >
          <Text size={"s"}>{toPrepareLabel}</Text>
          <CTagCustum
            status={"error"}
            hasBorder={false}
            size="l"
            width={isBreak === "phone" ? "100px" : "250px"}
          >
            {!isNaN(toPrepare)
              ? `${new Intl.NumberFormat("fr-FR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }).format(toPrepare)}`
              : "-"}
          </CTagCustum>
        </BoxCustom>
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
        >
          <Text size={"s"}>{prepareesLabel}</Text>
          <CTagCustum
            status={"warning"}
            hasBorder={false}
            size="l"
            width={isBreak === "phone" ? "100px" : "250px"}
          >
            {!isNaN(ready)
              ? `${new Intl.NumberFormat("fr-FR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }).format(ready)}`
              : "-"}
          </CTagCustum>
        </BoxCustom>
        <BoxCustom
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          textAlign={"left"}
        >
          <Text size={"s"}>{livreesLabel}</Text>
          <CTagCustum
            status={"success"}
            hasBorder={false}
            size="l"
            width={isBreak === "phone" ? "100px" : "250px"}
          >
            {!isNaN(delivered)
              ? `${new Intl.NumberFormat("fr-FR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                }).format(delivered)}`
              : "-"}
          </CTagCustum>
        </BoxCustom>
      </BoxCustom>
    </BoxCustom>
  );
};
export default OrderStatusCard;
